import firebase from "firebase";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBmRRbPNJuokRCpuuOY0HHj7QSIL-ZQvFc",
  authDomain: "casa-agis.firebaseapp.com",
  databaseURL: "https://casa-agis.firebaseio.com",
  projectId: "casa-agis",
  storageBucket: "casa-agis.appspot.com",
  messagingSenderId: "396246789979",
  appId: "1:396246789979:web:04340f35842527f042b47e",
  measurementId: "G-42KXNR326H"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const storageRef = storage.ref();
const auth = firebase.auth();

// firebase collections
// const categories = db.collection('categories');

export {
  firebase,
  db,
  storage,
  storageRef,
  auth
  // categories
}
